import { INIT_MAP_MARKERS, CLEAR_MAP_MARKERS } from '../type';

export const initMapMarkers = (markers) => ({
  type: INIT_MAP_MARKERS,
  payload: markers,
});

export const clearMapMarkers = () => ({
  type: CLEAR_MAP_MARKERS,
});
